import { Routes, Route, Navigate } from 'react-router-dom';
import Login from '../pages/Login';
import Dashboard from '../pages/Dashboard';
import Etiketler from '../pages/Etiketler';
import EtiketEkle from '../pages/Etiketler/create';
import Formlar from '../pages/Formlar';
import Reklamlar from '../pages/Reklamlar';
import Profil from '../pages/Profil';
import SifreDegistir from '../pages/SifreDegistir';
import FormDetay from '../pages/FormDetay';
import Logout from '../pages/Logout';
import ProtectedRoute from '../components/ProtectedRoute';
import Reports from '../pages/Reports';
import CustomerCreate from '../pages/Customer/create';
import HizmetEtiketleri from '../pages/Hizmet_Etiketleri';
import HizmetEtiketEkle from '../pages/Hizmet_Etiketleri/create';
import Hizmetler from '../pages/Hizmetler';
import HizmetDetay from '../pages/HizmetDetay';
import HedefKitle from '../pages/HedefKitle';
import TeklifRaporu from '../pages/TeklifRaporu';
import GoogleAds from '../pages/GoogleAds';
import Sozlesme from '../pages/Sozlesme';
import WhatsappInbox from '../pages/WhatsappInbox';
import Ayarlar from '../pages/Ayarlar';
import YoneticiPaneli from '../pages/YoneticiPaneli';

const AppRoutes = () => (
    <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/labels" element={<ProtectedRoute><Etiketler /></ProtectedRoute>} />
        <Route path="/create-label" element={<ProtectedRoute><EtiketEkle /></ProtectedRoute>} />
        <Route path="/service-labels" element={<ProtectedRoute><HizmetEtiketleri /></ProtectedRoute>} />
        <Route path="/create-service-label" element={<ProtectedRoute><HizmetEtiketEkle /></ProtectedRoute>} />
        <Route path="/forms" element={<ProtectedRoute><Formlar /></ProtectedRoute>} />
        <Route path="/services" element={<ProtectedRoute><Hizmetler /></ProtectedRoute>} />
        <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
        <Route path="/offer-report" element={<ProtectedRoute><TeklifRaporu /></ProtectedRoute>} />
        <Route path="/create-customer" element={<ProtectedRoute><CustomerCreate /></ProtectedRoute>} />
        <Route path="/lead-detail" element={<ProtectedRoute><FormDetay /></ProtectedRoute>} />
        <Route path="/service-detail" element={<ProtectedRoute><HizmetDetay /></ProtectedRoute>} />
        <Route path="/google-ads" element={<ProtectedRoute><GoogleAds /></ProtectedRoute>} />
        <Route path="/ads" element={<ProtectedRoute><Reklamlar /></ProtectedRoute>} />
        <Route path="/targeting-suggestion" element={<ProtectedRoute><HedefKitle /></ProtectedRoute>} />
        <Route path="/my-account" element={<ProtectedRoute><Profil /></ProtectedRoute>} />
        <Route path="/change-password" element={<ProtectedRoute><SifreDegistir /></ProtectedRoute>} />
        <Route path="/contract" element={<ProtectedRoute><Sozlesme /></ProtectedRoute>} />
        <Route path="/whatsapp-inbox" element={<ProtectedRoute><WhatsappInbox /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Ayarlar /></ProtectedRoute>} />
        <Route path="/yonetici-paneli" element={<ProtectedRoute><YoneticiPaneli /></ProtectedRoute>} />
        <Route path="*" element={<Navigate to="/login" />} />
    </Routes>
);

export default AppRoutes;
